import NewLeagueListingItem from "components/league/NewListingItem";
import moment, { ISO_8601 } from "moment";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import Navbar from "../../components/navbar";
import TIcon from "../../components/ui/TIcon";
import * as SBService from "../../helpers/sportbookService";
import { bottomBarState, loaderState, userState } from "../../states/common";

/**
 * Các giải mình đang tham gia — điểm vào khi bấm "Quét QR" để thi đấu.
 *
 * Dùng đúng thẻ giải của các màn danh sách khác (NewLeagueListingItem) thay vì
 * một bố cục riêng: trước đây màn này có thẻ, nút và cách xưng hô khác hẳn phần
 * còn lại của app dù hiển thị cùng một thứ.
 *
 * Chỉ liệt kê giải chưa qua ngày kết thúc: giải đã xong thì không còn trận nào
 * để bắt kèo, để trong danh sách chỉ làm người dùng bấm nhầm.
 */
const ScanQRSelection = () => {
  const navigate = useNavigate();
  const [, setActive] = useRecoilState(bottomBarState);
  const [, setLoader] = useRecoilState(loaderState);
  const [user] = useRecoilState(userState);
  const [leagues, setLeagues] = useState<any[]>([]);

  useEffect(() => {
    document.title = "Biadi — Giải đang tham gia";
    setActive("qr");

    const load = async () => {
      if (!user.id) return;
      setLoader(true);
      try {
        const rsp = await SBService.getLeagues({
          page: 1,
          limit: 50,
          onlyMyLeagues: true,
        });
        const now = moment();
        const rows = Array.isArray(rsp?.data) ? rsp.data : [];
        setLeagues(
          rows.filter((l: any) =>
            moment(l.endDate, ISO_8601).endOf("day").isAfter(now)
          )
        );
      } catch (e: any) {
        toast.error(
          e?.response?.data?.error
            ? "Có lỗi xảy ra: " + e.response.data.error
            : "Không tải được danh sách giải"
        );
      }
      setLoader(false);
    };

    load();
  }, [user.id]);

  return (
    <>
      <Navbar title="Giải đang tham gia" />

      <section className="section">
        {leagues.length > 0 ? (
          leagues.map((league: any, index) => (
            <NewLeagueListingItem
              key={`scan-league-${index}`}
              isShowScanBtn={false}
              isJoined={true}
              league={league}
            />
          ))
        ) : (
          <div className="ui-card empty-state">
            <TIcon name="trophy-off" />
            <div className="t">Bạn chưa tham gia giải nào đang diễn ra</div>
            <div className="h">Đăng ký một giải để bắt đầu thi đấu</div>
            <button
              type="button"
              className="btn btn-primary"
              style={{ marginTop: 14 }}
              onClick={() => navigate("/league")}
            >
              XEM GIẢI ĐẤU
            </button>
          </div>
        )}
      </section>
    </>
  );
};

export default ScanQRSelection;
